export const TAGS_FILTER = "tags"
export const CONDITIONS_FILTER = "conditions"
export const TYPE_FILTER = "type"

export const FILTERS = [
    TAGS_FILTER,
    CONDITIONS_FILTER,
    TYPE_FILTER,
]
